<mat-dialog-content>
  <h2 mat-dialog-title>{{ 'NO_PREFERRED_SITES.TITLE' | translate }}</h2>
  <p
    translate
    [translateParams]="{
      messageType: data.messageType
    }"
  >
    {{ 'NO_PREFERRED_SITES.PRESCRIPTION' }}
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button color="primary" (click)="goToPreferredSites()">
    {{ 'NO_PREFERRED_SITES.SELECT_PREFERRED_SITES' | translate }}
  </button>
  <button mat-button color="primary" (click)="goToCustomers()">
    {{ 'NO_PREFERRED_SITES.DO_IT_LATER' | translate }}
  </button>
</mat-dialog-actions>
